import { Tooltip } from 'antd';
import { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faEye, faFileArrowDown, faFileEdit, faPlus } from '@fortawesome/free-solid-svg-icons';


//STYLE
import { ContainerHeader } from './styled';

//APP
import { useFormOsContext } from '../../../../context/FormOsContext';

//COMPONENT
import ButtonCustom from '../../../../../../../../../../../../Components/ButtonCustom';
import ModalCriarMalha from './components/criarMalha';
import ModalEditarMalha from './components/editarMalha';
import { Box } from '../../../../../../../../../../../../Components/CustomUi/box';
import { Inline } from '../../../../../../../../../../../../Components/CustomUi/inline';
import { ModalVerMalha } from '../verMalha';
import { SelecionarTalhaoMalha } from '../selecionarTalhaoMalha';
import { EditarContorno } from './components/editarContorno';
import { ModalNovaAnalise } from './components/novaAnalise';
import { UploadFileCustom } from '../../../../../../../../../../../../Components/CustomUi/uploadFileCustom';

/** Cabeçalho da metade "Análises": ações (criar/importar/nova análise, editar contorno, ver malha) + infos. */
export function HeaderAnalises() {
    const {
        campos,
        analises: {
            malha,
            talhaoArea,
            pontosTotalMalha,
            importarMalha,
            talhaoKml,
            setTalhaoKml,
            salvarContornoEditado,
            setTalhaoArea,
            // Seleção de talhão (zip multi-talhão)
            abrirSelecaoTalhaoMalha,
            colecoesMalha,
            colecaoSelecionada,
            setColecaoSelecionada,
            confirmarTalhaoDaMalha,
            cancelarTalhaoDaMalha,
            setMalha,
            malhaShp,
            setMalhaShp,
            setPontosTotalMalha,
            // Edição de pontos da malha dentro do modal de análise
            moverPontoDaMalha,
            adicionarPontoNaMalha,
            // Nova análise
            grupoAnalises,
            grupoAnalisesTratado,
            abrirModalNova,
            setAbrirModalNova,
            id_em_edicao,
            cor,
            setCor,
            tipo_analise_selecionada,
            setTipo_analise_selecionada,
            tipo_analise_selecionada_id,
            setTipo_analise_selecionada_id,
            pontos_selecionados,
            setPontos_selecionados,
            pontos_selecionados_adicionados,
            setPontos_selecionados_adicionados,
            salvarPontosSelecionados,
            fecharModalNova,
            // Ver malha / editar contorno
            analises,
        },
    } = useFormOsContext()

    const [abrirCriarMalha, setAbrirCriarMalha] = useState(false)
    const [abrirEditarMalha, setAbrirEditarMalha] = useState(false)
    const [selecionarTodos, setSelecionarTodos] = useState(false)

    // Ver malha
    const [abrirVerMalha, setAbrirVerMalha] = useState(false)
    const [analises_ver, setAnalises_ver] = useState<any[]>([])
    const [selecionado, setSelecionado] = useState<number | null>(null)

    // Editar contorno
    const [abrirEditarContorno, setAbrirEditarContorno] = useState(false)

    const desabilitarNovaAnalise =
        (malha?.length ?? 0) === 0 || !talhaoArea || (grupoAnalises?.length ?? 0) === 0

    const desabilitarEditarContorno = !talhaoArea || Number(talhaoArea) === 0
    const desabilitarVerMalha = (analises?.length ?? 0) <= 0

    /**
     * Por que não é possível editar a malha, ou `undefined` quando é.
     * Sem contorno o mapa não tem talhão onde posicionar os pontos, e a edição
     * trataria todos eles como fora da área.
     */
    const motivoSemEditarMalha =
        (malha?.length ?? 0) === 0
            ? 'Importe ou crie uma malha para poder editá-la'
            : (talhaoKml?.length ?? 0) === 0
                ? 'Selecione um talhão com contorno cadastrado para editar a malha'
                : undefined

    function verMalhaGeral() {
        setAnalises_ver(analises)
        setAbrirVerMalha(true)
    }

    function fecharVerMalha() {
        setSelecionado(null)
        setAnalises_ver([])
        setAbrirVerMalha(false)
    }

    return (
        <ContainerHeader>
            <Inline alignItems='center'>
                <Box style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                    <Tooltip title="Criar Nova Malha"><span>
                        <ButtonCustom
                            icon={<FontAwesomeIcon icon={faPlus} />}
                            onClick={() => setAbrirCriarMalha(true)}
                        />
                    </span></Tooltip>
                    <Tooltip title={motivoSemEditarMalha ?? "Editar Malha atual"}><span>
                        <ButtonCustom
                            icon={<FontAwesomeIcon icon={faFileEdit} />}
                            type='secondary'
                            disabled={!!motivoSemEditarMalha}
                            onClick={() => setAbrirEditarMalha(true)}
                        />
                    </span></Tooltip>
                    <UploadFileCustom
                        label='Importar malha geral'
                        accept='.dbf, .shp, .shx, .zip'
                        onFileSelect={importarMalha}
                        style={{ height: 40, width: 240 }}
                        icon={faFileArrowDown}
                    />
                </Box>
                <Tooltip
                    title={
                        desabilitarNovaAnalise
                            ? 'Importe ou crie uma malha e selecione o laboratório primeiro'
                            : undefined
                    }
                >
                    <span>
                        <ButtonCustom
                            icon={<FontAwesomeIcon icon={faPlus} />}
                            disabled={desabilitarNovaAnalise}
                            onClick={() => setAbrirModalNova(true)}
                        >
                            Nova análise
                        </ButtonCustom>
                    </span>
                </Tooltip>
            </Inline>

            <Inline alignItems='center' justifyContent='space-between'>
                <div className='infos'>
                    <span>Pontos</span>
                    <p>{pontosTotalMalha}</p>
                </div>
                <div className='infos'>
                    <span>Área</span>
                    <p>{talhaoArea ? `${talhaoArea} ha` : '0 ha'}</p>
                </div>
                <ButtonCustom
                    type='tertiary'
                    icon={<FontAwesomeIcon icon={faEdit} />}
                    disabled={desabilitarEditarContorno}
                    onClick={() => setAbrirEditarContorno(true)}
                >
                    Editar contorno
                </ButtonCustom>
                <ButtonCustom
                    type='secondary'
                    icon={<FontAwesomeIcon icon={faEye} />}
                    disabled={desabilitarVerMalha}
                    onClick={verMalhaGeral}
                >
                    Ver malha
                </ButtonCustom>
            </Inline>

            <ModalCriarMalha
                isOpen={abrirCriarMalha}
                onClose={() => setAbrirCriarMalha(false)}
                talhaoKml={talhaoKml}
                setTalhaoKml={setTalhaoKml}
                setTalhaoArea={setTalhaoArea}
                setMalha={setMalha}
                setMalhaShp={setMalhaShp}
                setPontosTotalMalha={setPontosTotalMalha}
            />

            <ModalEditarMalha
                isOpen={abrirEditarMalha}
                onClose={() => setAbrirEditarMalha(false)}
                talhaoKml={talhaoKml}
                setTalhaoKml={setTalhaoKml}
                setTalhaoArea={setTalhaoArea}
                setMalha={setMalha}
                setMalhaShp={setMalhaShp}
                setPontosTotalMalha={setPontosTotalMalha}
                malhaExistente={malha}
                nomeTalhaoInicial={malhaShp?.fileName ?? campos.talhao}
                possuiAnalises={(analises?.length ?? 0) > 0}
            />

            <ModalNovaAnalise
                isOpen={abrirModalNova}
                onClose={fecharModalNova}
                talhaoGeoJson={talhaoKml}
                initialPoints={malha}
                id={id_em_edicao}
                cor={cor}
                setCor={setCor}
                tipo_analise_selecionada={tipo_analise_selecionada}
                setTipo_analise_selecionada={setTipo_analise_selecionada}
                tipo_analise_selecionada_id={tipo_analise_selecionada_id}
                setTipo_analise_selecionada_id={setTipo_analise_selecionada_id}
                pontos_selecionados={pontos_selecionados}
                setPontos_selecionados={setPontos_selecionados}
                pontos_selecionados_adicionados={pontos_selecionados_adicionados}
                setPontos_selecionados_adicionados={setPontos_selecionados_adicionados}
                moverPontoDaMalha={moverPontoDaMalha}
                adicionarPontoNaMalha={adicionarPontoNaMalha}
                selecionarTodos={selecionarTodos}
                setSelecionarTodos={setSelecionarTodos}
                grupoAnalises={grupoAnalises}
                grupoAnalisesTratado={grupoAnalisesTratado}
                salvarPontosSelecionados={salvarPontosSelecionados}
                analises_salvas={analises}
            />

            <ModalVerMalha
                isOpen={abrirVerMalha}
                onClose={fecharVerMalha}
                talhaoGeoJson={talhaoKml}
                initialPoints={malha}
                analises={analises_ver}
                selecionado={selecionado}
                setSelecionado={setSelecionado}
                nomePropriedade={campos.propriedade}
                nomeTalhao={campos.talhao}
            />

            <SelecionarTalhaoMalha
                abrir={abrirSelecaoTalhaoMalha}
                colecoes={colecoesMalha}
                selecionada={colecaoSelecionada}
                aoSelecionar={setColecaoSelecionada}
                aoConfirmar={confirmarTalhaoDaMalha}
                aoCancelar={cancelarTalhaoDaMalha}
            />

            <EditarContorno
                aberto={abrirEditarContorno}
                contornoInicial={talhaoKml}
                pontos={malha}
                aoFechar={() => setAbrirEditarContorno(false)}
                aoSalvar={(coords) => salvarContornoEditado(coords)}
            />
        </ContainerHeader>
    )
}
